export default __webpack_public_path__ + "static/media/SprintDetailsTimeline.6d732d9c.png";